import { RootState } from "@/redux/store";

export const selectQuickSetupNavigation = (state: RootState) => state.quickSetup;

export const selectCameFromQuickSetup = (state: RootState) => state.quickSetup.cameFromQuickSetup;

export const selectLastClickedSection = (state: RootState) => state.quickSetup.lastClickedSection;

export const selectShouldShowBanner = (state: RootState) => state.quickSetup.cameFromQuickSetup;

export const selectLastOpenedPanel = (state: RootState) => state.quickSetup.lastOpenedPanel;

export const selectHasSeenOnboardingCompleteModal = (state: RootState) => state.quickSetup.hasSeenOnboardingCompleteModal;

export const selectHasSeenSimulationCompleteSnackbar = (state: RootState) => state.quickSetup.hasSeenSimulationCompleteSnackbar;

export const selectHasSeenPreSimulationModal = (state: RootState) => state.quickSetup.hasSeenPreSimulationModal;

export const selectIsOnboardingComplete = (state: RootState) => state.quickSetup.isOnboardingComplete;
